import script from "./AppHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHeader.vue?vue&type=script&setup=true&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=b65e0b18&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b65e0b18"]])

export default __exports__